import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimString',
  standalone: true,
})
export class TrimStringPipe implements PipeTransform {
  transform(value: string, maxLength: number): string {
    if (!value) return '';
    if (value.length <= maxLength) {
      return value;
    } else {
      // Trim the string to the specified maxLength and add three dots at the end

      return value.slice(0, maxLength) + '...';
    }
  }
}
